import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Petitii() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/petitions").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div data-testid="page-petitii" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-12">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Activism civic</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Petiții care pot schimba vieți</h1>
        <p className="mt-4 text-[#A0AABF] text-lg max-w-3xl">Schimbarea începe atunci când oamenii aleg să nu mai tacă. Semnează — și distribuie.</p>
      </header>

      <div className="grid md:grid-cols-2 gap-6">
        {items.map(p => {
          const pct = Math.min(100, (p.current_signatures / p.goal_signatures) * 100);
          return (
            <Link key={p.petition_id} to={`/petitii/${p.slug}`} data-testid={`pet-${p.slug}`} className="cinematic-card rounded-lg p-6 md:p-8 group block">
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4A63D]">{p.status === "active" ? "Activă" : p.status}</span>
              <h3 className="font-display text-xl md:text-2xl text-[#F8F8F4] group-hover:text-[#D4A63D] mt-2 leading-snug">{p.title}</h3>
              <p className="text-sm text-[#A0AABF] mt-3 line-clamp-3">{p.problem_statement}</p>
              <div className="mt-5">
                <div className="flex items-center justify-between text-xs mb-2">
                  <span className="text-[#D4A63D] font-medium">{p.current_signatures.toLocaleString("ro-RO")} semnături</span>
                  <span className="text-[#6C7A9C]">obiectiv {p.goal_signatures.toLocaleString("ro-RO")}</span>
                </div>
                <div className="h-2 bg-[#0A1020] rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-[#D4A63D] to-[#F2C053]" style={{ width: `${pct}%` }} />
                </div>
              </div>
              <div className="mt-5 text-sm text-[#F8F8F4]/80 inline-flex items-center gap-1 group-hover:text-[#D4A63D]">Citește & semnează <ArrowRight className="w-4 h-4" /></div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
